module.exports = (__webpack_require__(2))(60);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/UserCollection.js from dll-reference girder_lib
// module id = 43
// module chunks = 0